import { render } from "./AddYearButton.vue?vue&type=template&id=2cf37759&scoped=true&ts=true"
import script from "./AddYearButton.vue?vue&type=script&lang=ts"
export * from "./AddYearButton.vue?vue&type=script&lang=ts"

import "./AddYearButton.vue?vue&type=style&index=0&id=2cf37759&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\y-tosa.LOCALPSC\\repo\\seto-solan\\apps\\admin-app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2cf37759"]])

export default __exports__